export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

// Groups raw reactions ([{emoji, actor_type, actor_id, actor_name}]) into chips.
export const groupReactions = (reactions = [], currentUserId = null) => {
  const groups = new Map();
  reactions.forEach(reaction => {
    const emoji = reaction.emoji;
    if (!emoji) return;
    const group = groups.get(emoji) || {
      emoji,
      count: 0,
      names: [],
      mine: false,
    };
    group.count += 1;
    group.names.push(reaction.actor_name || reaction.actorName || '');
    const actorType = reaction.actor_type || reaction.actorType;
    const actorId = Number(reaction.actor_id || reaction.actorId);
    if (actorType === 'User' && actorId === Number(currentUserId)) {
      group.mine = true;
    }
    groups.set(emoji, group);
  });
  return [...groups.values()];
};

export const myReaction = (reactions = [], currentUserId = null) =>
  reactions.find(
    r =>
      (r.actor_type || r.actorType) === 'User' &&
      Number(r.actor_id || r.actorId) === Number(currentUserId)
  )?.emoji || '';
